import { VOUCHERS_ROUTES } from '../../constants/_routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'

const import_vouchers_csv_request = () => {
  return {
    type: vouchersTypes.import_csv.request
  }
}

const import_vouchers_csv_success = (response) => {
  return {
    type: vouchersTypes.import_csv.success,
    payload: response.data
  }
}

const import_vouchers_csv_failure = (messages) => {
  return {
    type: vouchersTypes.import_csv.failure,
    payload: messages
  }
}

const import_vouchers_csv = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(import_vouchers_csv_request())

    // Request
    axios.post(
      VOUCHERS_ROUTES.import_csv,
      values
    ).then( response => {
      // success
      window.showSnackbar('success', "Vouchers have been processed")
      dispatch( import_vouchers_csv_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error processing vouchers file."]
      }
      window.showSnackbar('error', errors)
      dispatch( import_vouchers_csv_failure(errors))
    })
  }

}

export {
  import_vouchers_csv
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/import_csv.js